module.exports = "/_next/static/images/7ea8ba2c44f4b8aa5adee074f946bd78-diana_1@3x.png.webp";